import { Box, Chip } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ReusableTable from '../../common/table/CommonTable';


const DoctorPatientList = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientList = useSelector((state) => state?.patients?.fetchListPatients || {});
  const [data, setData] = useState();

const columns = [
  { 
    id: 'id', 
    label: 'Patient Id Number', 
    sortable: true 
  },
  { 
    id: 'name', 
    label: 'Patient Name', 
    sortable: true 
  },
  { 
    id: 'attenderName', 
    label: 'Attender Name', 
    sortable: true,
    render: (value) => value ? value : 'N/A'  
  },
  { 
    id: 'block', 
    label: 'Block', 
    sortable: true 
  },
  { 
    id: 'floor', 
    label: 'Floor', 
    sortable: true 
  },
  { 
    id: 'section', 
    label: 'Section', 
    sortable: true 
  },
  { 
    id: 'wardNo', 
    label: 'Ward Number', 
    sortable: true 
  },
  { 
    id: 'bedNo', 
    label: 'Bed Number', 
    sortable: true 
  },
  { 
    id: 'phone', 
    label: 'Phone', 
    sortable: true 
  },
  { 
    id: 'joinDate', 
    label: 'Join Date', 
    sortable: true,
    render: (value) => {
      const date = new Date(value);
      return isNaN(date) ? 'Invalid Date' : date.toLocaleDateString();
    }
  },
  { 
    id: 'dischargeDate', 
    label: 'Discharge Date', 
    sortable: true,
    render: (value) => {
      const date = new Date(value);
      return isNaN(date) ? 'Invalid Date' : date.toLocaleDateString();
    }
  },
  { 
    id: 'status', 
    label: 'Status', 
    sortable: true,
    render: (value) => (
      <Chip label={value} color={value === 'Active' ? 'success' : 'warning'} />
    )
  },
];
  return (
    <Box>
      <ReusableTable
        title="Patients"
        columns={columns}
        data={data}
        isLoading={loading}
        headerColor="#000" 
        rowColor="#ffffff" 
        alternateRowColor="#f5f5f5" 
        withPagination={true}
        withActions={false}
        rowsPerPage={10}
        showDownloadOption={true} 
      />
    </Box>
  );
};

export default DoctorPatientList;
